import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import {
  List,
  Typography,
  Select,
  Button,
  message,
  DatePicker,
  Divider,
  Spin,
} from "antd";
import { db } from "./FirebaseConfig"; // あなたの Firebase 初期化ファイルに応じて修正
import dayjs from "dayjs";

const { Title } = Typography;
const { Option } = Select;

const AdminUserManager = () => {
  const [userIds, setUserIds] = useState([]);
  const [selectedUid, setSelectedUid] = useState(null);
  const [userData, setUserData] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        const ids = snapshot.docs.map((doc) => doc.id);
        setUserIds(ids);
      } catch (err) {
        console.error("ユーザー一覧取得エラー:", err);
        message.error("ユーザー一覧の取得に失敗しました。");
      }
    };

    fetchUserList();
  }, []);

  const fetchUserDetail = async (uid) => {
    setSelectedUid(uid);
    setLoading(true);
    try {
      const snap = await getDoc(doc(db, "users", uid));
      if (snap.exists()) {
        const data = snap.data();
        setUserData(data);
        setEditedData({
          plan: data.plan || "basic",
          role: data.role || "viewer",
          startAt: data.subscription?.startAt?.toDate() || null,
          endAt: data.subscription?.endAt?.toDate() || null,
        });
      } else {
        setUserData(null);
        setEditedData(null);
        message.warning("このユーザーのデータは存在しません。");
      }
    } catch (err) {
      console.error("ユーザー詳細取得エラー:", err);
      message.error("ユーザーの詳細取得に失敗しました。");
    } finally {
      setLoading(false);
    }
  };

  const handleFieldChange = (field, value) => {
    setEditedData((prev) => ({ ...prev, [field]: value }));
  };

  const handleDateChange = (field, date) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: date ? date.toDate() : null,
    }));
  };

  const handleSave = async () => {
    if (!selectedUid || !editedData) return;
    setSaving(true);
    try {
      await updateDoc(doc(db, "users", selectedUid), {
        subscription: {
          startAt: editedData.startAt
            ? Timestamp.fromDate(editedData.startAt)
            : null,
          endAt: editedData.endAt
            ? Timestamp.fromDate(editedData.endAt)
            : null,
        },
        updatedAt: Timestamp.now(),
      });
      message.success("ユーザー情報を更新しました");
    } catch (err) {
      console.error("保存エラー:", err);
      message.error("保存に失敗しました");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>ユーザー管理</Title>
      <Divider />
      <div style={{ display: "flex", gap: "24px" }}>
        {/* 左カラム：ユーザー一覧 */}
        <div style={{ flex: 1, maxHeight: "80vh", overflowY: "auto" }}>
          <List
            bordered
            header={<strong>UID一覧</strong>}
            dataSource={userIds}
            renderItem={(uid) => (
              <List.Item
                style={{
                  cursor: "pointer",
                  backgroundColor: uid === selectedUid ? "#e6f7ff" : "white",
                }}
                onClick={() => fetchUserDetail(uid)}
              >
                {uid}
              </List.Item>
            )}
          />
        </div>

        {/* 右カラム：ユーザー詳細 */}
        <div style={{ flex: 2 }}>
          {loading ? (
            <Spin tip="読み込み中..." />
          ) : userData && editedData ? (
            <div>
              <h3>ユーザー詳細</h3>
              <p>
                <strong>表示名：</strong> {userData.displayName}
              </p>
              <p>
                <strong>メール：</strong> {userData.email}
              </p>
              <p>
                <strong>場所：</strong> {userData.location}
              </p>
              <p>
                <strong>会社：</strong> {userData.campany}
              </p>
              <div style={{ marginBottom: 12 }}>
                <strong>契約開始日：</strong>
                <DatePicker
                  value={
                    editedData.startAt ? dayjs(editedData.startAt) : null
                  }
                  onChange={(d) => handleDateChange("startAt", d)}
                  format="YYYY/MM/DD"
                />
              </div>

              <div style={{ marginBottom: 12 }}>
                <strong>契約終了日：</strong>
                <DatePicker
                  value={editedData.endAt ? dayjs(editedData.endAt) : null}
                  onChange={(d) => handleDateChange("endAt", d)}
                  format="YYYY/MM/DD"
                />
              </div>

              <Button type="primary" onClick={handleSave} loading={saving}>
                保存する
              </Button>
            </div>
          ) : (
            <p>ユーザーを選択してください。</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminUserManager;
